import type { IBudgetLimitsTransactionType } from './queries/budget-limit.graphql';
import type { ISuspensionLimitsType } from './queries/suspension-limit.graphql';

export enum UserBudgetLimitMediatorTypeView {
    SPORTS = 'sports',
    CASINO = 'casino',
    DEPOSIT = 'deposit',
}

export enum SuspensionLimitsType {
    TIMEOUT,
    EXCLUSION,
}

export enum SessionContextType {
    LOGIN = 'login',
    GAMING = 'gaming',
}

export enum UserLimitPeriod {
    PT1M = 'PT1M',
    PT2M = 'PT2M',
    PT30M = 'PT30M',
    PT1H = 'PT1H',
    PT2H = 'PT2H',
    PT5H = 'PT5H',
    PT7H = 'PT7H',
    PT10H = 'PT10H',
    PT15H = 'PT15H',
    P1D = 'P1D',
    P7D = 'P7D',
    P14D = 'P14D',
    P30D = 'P30D',
    P3M = 'P3M',
    P6M = 'P6M',
    P1Y = 'P1Y',
    INDEFINITE = 'INDEFINITE',
}

export interface IUserLimit {
    type: BudgetLimitsTransactionTypes;
    period: UserLimitPeriod;
    amount: number;
    currencyCode: string;
}

export interface IUserMaxWagerLimit {
    type: IBudgetLimitsTransactionType;
    amount: number;
    currencyCode: string;
}

export interface IUserSessionContinuousLimit {
    duration: UserLimitPeriod;
    createdBy: string;
    cooldown: UserLimitPeriod;
    period: string;
}

export interface IUserSessionCumulativeLimit {
    createdBy: string;
    duration: UserLimitPeriod;
    period: string;
}

export interface IUserSelfExcludeLimit {
    duration: UserLimitPeriod;
    createdBy: string;
    intent: ISuspensionLimitsType;
}

export enum BudgetLimitsTransactionTypes {
    Wagering = 'WAGERING',
    Loss = 'LOSS',
    Deposit = 'DEPOSIT',
    MaxWager = 'MAXWAGER',
}
